import Vue from 'vue'
import Router from 'vue-router'
import LayoutWorks from '@/components/layouts/Works'
import WorksTop from '@/components/WorksTop'
import WorksDetail from '@/components/WorksDetail'
import Contact from '@/components/Contact'
import Profile from '@/components/Profile'
import Top from '@/components/Top'
import PageNotFound from '@/components/PageNotFound'

Vue.use(Router)

export default new Router({
    base: '/testing/vue/build/',
    mode: 'history',
    routes: [
        {//トップページ
            path: '/',
            name: 'Top',
            component: Top
        },
        {
            path:'/works',
            component:LayoutWorks,
            children:[
                {//作品一覧ページ
                    path: '/',
                    name: 'WorksTop',
                    component: WorksTop
                },
                {//作品詳細ページ
                    path: ':slug',
                    name: 'WorksDetail',
                    component: WorksDetail
                }
            ]
        },
        {//お問い合わせ
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {//プロフィール
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {//404ページルーティングは一番下に
            path: '*',
            name: 'Not Found',
            component: PageNotFound,
            title:'Not Found'
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js